import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpunecontact() {



    const cardData =
    {
        keyword: 'Urbania on Rent in Pune Contact Number',
        heading: 'Urbania on rent in pune: Urbania on Rent in Pune Contact Number',
        headingDescription: 'Urbania On Rent in Pune provides premium and dependable Urbania rental services for corporate groups, families, tourists, and event travelers across Pune and nearby destinations. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, ample luggage space, and smooth performance, making it ideal for airport transfers, corporate travel, weddings, sightseeing tours, pilgrimages, and outstation journeys. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from all major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. For quick booking and the best service, contact Urbania on Rent in Pune Contact Number: +91 9209423113, backed by 24/7 customer support, transparent pricing, and trusted service.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Urbania on Rent in Pune Contact Number",
"description": "Urbania on Rent in Pune Contact Number helps customers easily connect for Urbania bus rental enquiries in Pune. This service is designed to provide quick assistance for booking Urbania buses for family trips, corporate travel, weddings, tours, and outstation journeys. By contacting the service team, customers can get detailed information about vehicle availability, pricing options, AC and non-AC variants, seating capacity, and travel planning. The focus is on clear communication, quick response, and smooth booking support to ensure a hassle-free rental experience."
},
{
"name": "Urbania Rental Service Pune Contact",
"description": "Urbania Rental Service Pune Contact offers direct assistance for customers looking to hire Urbania buses in Pune. The support team provides complete guidance regarding rental packages, trip customization, and vehicle features. Whether the requirement is for a short local trip or a long-distance journey, this contact service ensures customers receive accurate information, professional support, and reliable service coordination from enquiry to trip completion."
},
{
"name": "Urbania Bus Hire Pune Phone Number",
"description": "Urbania Bus Hire Pune Phone Number connects customers with trained representatives who assist in booking Urbania buses for various travel needs. From weddings and corporate events to family tours and pilgrimages, the phone support ensures quick confirmations and clear explanations of rental terms. Customers can discuss travel routes, timing, vehicle preferences, and special requirements, making the entire booking process simple and transparent."
},
{
"name": "Urbania Booking Pune Contact",
"description": "Urbania Booking Pune Contact provides a convenient way to reserve Urbania buses with professional assistance. Customers can enquire about availability, pricing, and customized travel plans through this contact point. The booking team ensures smooth coordination, timely confirmations, and accurate details, helping travelers plan stress-free journeys for local, outstation, and event-based travel."
},
{
"name": "Urbania Customer Care Pune",
"description": "Urbania Customer Care Pune focuses on delivering dedicated support before, during, and after the rental process. The customer care team assists with enquiries, booking support, trip modifications, and general service information. With a customer-first approach, the service ensures clear communication, reliable guidance, and quick issue resolution for a smooth Urbania rental experience in Pune."
},
{
"name": "Urbania Rental Helpline Pune",
"description": "Urbania Rental Helpline Pune offers responsive assistance for customers seeking Urbania bus rental services. The helpline supports enquiries related to vehicle selection, rental duration, pricing, and route planning. Ideal for families, corporate clients, and group travelers, this helpline ensures professional guidance and dependable support for all types of Urbania travel requirements."
},
{
"name": "Urbania Hire Service Pune Contact Details",
"description": "Urbania Hire Service Pune Contact Details provide easy access to complete information about Urbania bus hire services. Customers can connect to understand rental options, safety features, driver experience, and service coverage. This contact support is designed to simplify decision-making and ensure a well-planned, comfortable, and reliable travel experience."
},
{
"name": "Urbania Booking Number Pune",
"description": "Urbania Booking Number Pune helps customers quickly initiate bookings for Urbania buses in Pune. The booking team assists with confirming availability, explaining rental terms, and organizing travel schedules. Whether it is a one-day hire or a multi-day tour, this service ensures efficient booking and dependable coordination."
},
{
"name": "Urbania Bus Rental Pune Contact Number",
"description": "Urbania Bus Rental Pune Contact Number provides direct access to professional support for hiring Urbania buses. Customers can discuss travel requirements, seating capacity, luggage needs, and trip routes with knowledgeable staff. The service ensures clarity, reliability, and personalized assistance for all Urbania rental needs."
},
{
"name": "Urbania Support Pune",
"description": "Urbania Support Pune offers ongoing assistance for customers using Urbania rental services. From enquiry and booking to trip execution, the support team ensures smooth communication and reliable service. This support system is ideal for customers who value prompt responses, clear guidance, and dependable coordination throughout their journey."
},
{
"name": "Best Urbania Rental Pune Contact",
"description": "Best Urbania Rental Pune Contact connects customers with a trusted service team known for quality vehicles and professional handling. Customers can enquire about premium Urbania options, travel packages, and customized requirements. The focus is on delivering high service standards, comfort, and customer satisfaction."
},
{
"name": "Urbania Enquiry Number Pune",
"description": "Urbania Enquiry Number Pune allows customers to gather complete information before booking an Urbania bus. The enquiry service covers pricing details, vehicle features, driver experience, and travel feasibility. This ensures customers can make informed decisions and plan their journeys confidently."
},
{
"name": "Urbania Service Phone Pune",
"description": "Urbania Service Phone Pune offers a simple and reliable way to communicate with the Urbania rental team. Customers can resolve doubts, request quotations, and confirm travel arrangements through direct phone support. The service emphasizes professionalism, clarity, and prompt assistance."
},
{
"name": "Urbania Rent Pune Call Now",
"description": "Urbania Rent Pune Call Now is designed for customers seeking immediate assistance for Urbania bus rentals. This service helps with quick enquiries, urgent bookings, and last-minute travel needs. With responsive support and clear communication, customers can arrange their travel efficiently and confidently."
},
{
"name": "Urbania Hire Pune Contact Info",
"description": "Urbania Hire Pune Contact Info provides complete access to support for hiring Urbania buses in Pune. Customers can enquire about local travel, outstation trips, weddings, corporate transport, and group tours. The service ensures a smooth booking process, professional coordination, and reliable travel support from start to finish."
}
],
"tableData": [
["Urbania on Rent in Pune Contact Number", "Urbania Rental Service Pune Contact"],
["Urbania Bus Hire Pune Phone Number", "Urbania Booking Pune Contact"],
["Urbania Customer Care Pune", "Urbania Rental Helpline Pune"],
["Urbania Hire Service Pune Contact Details", "Urbania Booking Number Pune"],
["Urbania Bus Rental Pune Contact Number", "Urbania Support Pune"],
["Best Urbania Rental Pune Contact", "Urbania Enquiry Number Pune"],
["Urbania Service Phone Pune", "Urbania Rent Pune Call Now"],
["Urbania Hire Pune Contact Info", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania on Rent in Pune with Easy Contact Booking",
        "WhyChoosedescription": "Urbania on Rent in Pune is ideal for outstation trips, weddings, corporate travel, family tours, and group journeys. For quick booking and inquiries, contact us directly at +91 9209423113."
    },
    {
        "WhyChooseheading": "Spacious and Luxury Urbania Vehicles",
        "WhyChoosedescription": "Our Urbania vehicles in Pune come with air-conditioning, push-back seats, ample legroom, and sufficient luggage space to ensure a comfortable and premium travel experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced with Pune city and outstation routes, ensuring safe, punctual, and smooth journeys."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania on Rent in Pune offers competitive pricing with no hidden charges. Call +91 9209423113 for the best deals and clear cost details."
    },
    {
        "WhyChooseheading": "24/7 Booking Support via Call",
        "WhyChoosedescription": "We provide round-the-clock booking assistance. You can contact us anytime at +91 9209423113 for reservations and travel-related queries."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local Pune travel, outstation trips, corporate events, weddings, and customized itineraries as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles are regularly cleaned, sanitized, and well-maintained to ensure passenger safety, hygiene, and comfort."
    },
    {
        "WhyChooseheading": "Reliable and Punctual Service",
        "WhyChoosedescription": "Our Urbania on Rent in Pune service ensures on-time pickups, reliable travel support, and a hassle-free experience for every journey."
    }
]
}
const faqData = [
    {
        question: 'How can I contact Urbania on Rent in Pune?',
        answer: 'You can directly call or WhatsApp on +91 9209423113 for bookings and inquiries.'
    },
    {
        question: 'Is Urbania on Rent in Pune available for outstation trips?',
        answer: 'Yes, Urbania vehicles are available for outstation travel, long-distance tours, and multi-day journeys.'
    },
    {
        question: 'Why choose Urbania on Rent in Pune?',
        answer: 'It offers comfortable seating, professional drivers, clean vehicles, flexible packages, and transparent pricing.'
    },
    {
        question: 'Are the drivers experienced?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with Pune and outstation routes.'
    },
    {
        question: 'Can I customize pickup and drop locations?',
        answer: 'Absolutely. Flexible pickup and drop-off options are available across Pune and nearby areas.'
    },
    {
        question: 'Is booking available 24/7?',
        answer: 'Yes, you can contact +91 9209423113 anytime for 24/7 booking and customer support.'
    },
    {
        question: 'Are hygiene and safety standards followed?',
        answer: 'Yes, all Urbania vehicles are cleaned, sanitized, and maintained regularly.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments are accepted via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is Urbania suitable for weddings and corporate travel?',
        answer: 'Yes, Urbania on Rent in Pune is ideal for weddings, corporate travel, family trips, and group tours.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sanjay Kulkarni',
        feedback: 'I contacted Urbania on Rent in Pune using the given number and received quick confirmation. The vehicle was clean and very comfortable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Pooja Pawar',
        feedback: 'Excellent service and easy booking through phone. Calling +91 9209423113 made the entire process smooth and hassle-free.',
        rating: 5
    }
];



















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pune Contact Number",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-contact-pune.jpg",
  "description": "Urbania on Rent in Pune Contact Number provides direct access to booking, customer support, and enquiry services for AC and luxury Urbania buses. Call for corporate travel, wedding buses, outstation trips, and group travel in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-in-pune-contact-number"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania on Rent in Pune Contact Number | Booking & Customer Support 
  </title>

  <meta
    name="description"
    content="Contact Urbania on Rent in Pune for booking, customer support, and enquiries. Get assistance for corporate travel, weddings, outstation trips, and group travel with AC and luxury Urbania buses in Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Pune Contact Number, Urbania Rental Service Pune Contact, Urbania Bus Hire Pune Phone Number, Urbania Booking Pune Contact, Urbania Customer Care Pune, Urbania Rental Helpline Pune, Urbania Hire Service Pune Contact Details, Urbania Booking Number Pune, Urbania Bus Rental Pune Contact Number, Urbania Support Pune, Best Urbania Rental Pune Contact, Urbania Enquiry Number Pune, Urbania Service Phone Pune, Urbania Rent Pune Call Now, Urbania Hire Pune Contact Info"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/114.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpunecontact;